import React from "react";

import { SvgIcon, SvgIconProps } from "@mui/material";

import { colors } from "@/theme/overrides/colors";

const NoWaterIntakeIcon: React.FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon viewBox="0 0 52 47" {...props}>
      <path
        d="M38.7826 16.31L25.9961 0L13.1927 16.3317C11.1043 19.1147 10 22.4311 10 25.9219C10 34.7419 17.1761 42 25.9961 42C34.8161 42 41.9922 34.7419 41.9922 25.9219C41.9922 22.4311 40.8879 19.1147 38.7826 16.31Z"
        fill="#C0C5CD"
      />
      <path
        d="M1.66772 42.0044L49.6679 6.6709"
        stroke={colors.light}
        strokeWidth="3.33335"
      />
      <path
        d="M3.00049 44.6641L51.0007 9.33057"
        stroke="#C0C5CD"
        strokeWidth="3.33335"
      />
    </SvgIcon>
  );
};

export default NoWaterIntakeIcon;
